var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.49 68.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.73,68.57c-1.89-4.79-3.81-9.57-5.67-14.38-.8-2.08-1.42-4.23-2.19-6.33C46.45,44,45,40.15,43.52,36.31Q38.35,23,33.1,9.74c-.1-.27-.22-.54-.39-.94l-4.3,11c-3.22,8.25-6.63,16.44-9.59,24.79-2.84,8-5.92,15.82-9,23.7a.93.93,0,0,0,0,.24q-4.59,0-9.21,0H0C1.62,64.7,2.82,61.65,3.45,60,11.11,40.18,19.28,20.55,27.17.81A1.05,1.05,0,0,1,28.34,0c3,0,6,0,9,0a.89.89,0,0,1,1,.66Q48.81,27,59.31,53.28c.53,1.33,3.25,6.89,5.89,14.75q.12.34.18.54H55.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.42,68.57,67,62.45c-.17-.45-.35-.9-.53-1.37,1.37,0,2.69.05,4,0a26,26,0,0,0,16.09-6.39A1.93,1.93,0,0,0,87.34,53c0-3.83,0-7.65,0-11.48,0-.72-.19-.92-.91-.91-6.94,0-13.89,0-20.84,0h-1V33.37c.3,0,.59,0,.88,0,9.69,0,19.38,0,29.07,0,.79,0,1,.24,1,1,0,7.33,0,14.65,0,22a2.13,2.13,0,0,1-.51,1.35A33.57,33.57,0,0,1,74.41,68.26c-.64.09-1.27.21-1.9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.6.1a33.28,33.28,0,0,1,3.6.41,33.77,33.77,0,0,1,8.5,2.6,33.06,33.06,0,0,1,11.49,9.28l-6.54,4.17a24.29,24.29,0,0,0-20-9.08,24.41,24.41,0,0,0-19.55,10.1c-.12-.25-.24-.45-.32-.65-.94-2.34-1.86-4.69-2.83-7a.92.92,0,0,1,.27-1.23,33,33,0,0,1,5.63-4.06A31.49,31.49,0,0,1,63.71.52,34.91,34.91,0,0,1,67.23.08Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.b112bf633b6e25fc1823e1a27f2c4e9b.svg";
export { ForwardRef as ReactComponent };